import { render } from "./Notifiche45Giorni.vue?vue&type=template&id=4088e44e&scoped=true"
import script from "./Notifiche45Giorni.vue?vue&type=script&lang=js"
export * from "./Notifiche45Giorni.vue?vue&type=script&lang=js"

import "./Notifiche45Giorni.vue?vue&type=style&index=0&id=4088e44e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4088e44e"]])

export default __exports__